var React = require('react');

function PropertyType (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M51.9996 51.5476L37.2188 60.5105V26.5365L51.9996 17.562V51.5476Z","fill":"#F8FAFD","key":0}),React.createElement("path",{"d":"M26.7808 3L12 11.963L37.2184 26.5364L51.9993 17.562L26.7808 3Z","fill":"#EEEEF4","key":1}),React.createElement("path",{"d":"M12 45.9485L37.2184 60.5104V26.5364L12 11.9629V45.9485Z","fill":"#DCE0F1","key":2}),React.createElement("path",{"d":"M43.6133 37.8958L39.6387 40.1884V29.4052L43.6133 27.1011V37.8958Z","fill":"#3E3C5C","key":3}),React.createElement("path",{"d":"M14.4072 41.732L20.0868 45.0153V23.5641L14.4072 20.2808V41.732Z","fill":"#9BBAE7","key":4})]);
}

PropertyType.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = PropertyType;

PropertyType.default = PropertyType;
